// @ts-nocheck
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";

type ResponsiveOptionsValuesMapperOptions = {
    overridedDefaultValuesObj?: HasFields;
};

/**
 *  Maps the given values to a HasFields object
 *
 * @param values - The values to map
 * @param options - A set of options to map the values
 * @returns - A HasFields object with the mapped values
 */
export default (values: HasFields["fields"], options?: ResponsiveOptionsValuesMapperOptions) => {
    const valuesFields: HasFields = options?.overridedDefaultValuesObj || {
        fields: {},
    };

    for (const key in values) {
        if (Object.prototype.hasOwnProperty.call(values, key)) {
            const element = values[key];
            valuesFields.fields[key] = element;
        }
    }

    return valuesFields;
};
